/* eslint-disable max-lines */
// 满意度
export const satisfactionColumnConfig = {
    height: '200px',
    columns: [
        {
            label: '客户名称',
            prop: 'angleName'
        },
        {
            label: '本年度调研满意次数',
            prop: 'satisfiedCnt'
        },
        {
            label: '本年度调研总次数',
            prop: 'investigationCnt'
        },
        {
            label: '满意度',
            prop: 'satisfiedPct'
        },
        {
            label: '回访电话接通次数',
            prop: 'efftiveCnt'
        },
        {
            label: '回访电话总次数',
            prop: 'investigationCnt'
        },
        {
            label: '接通率',
            prop: 'efftivePct'
        }
    ]
};

// 工单明细明细
export const orderColumnsConfig = {
    height: '200px',
    columns: [
        {
            label: '客户名称',
            prop: 'angleName'
        },
        {
            label: '及时闭环工单数量',
            prop: 'sumInTimeCnt',
            width: '120px'
        },
        {
            label: '工单总数量',
            prop: 'sumCnt'
        },
        {
            label: '工单闭环及时率',
            prop: 'sumInTimePct',
            width: '110px'
        },
        {
            label: '投诉工单及时闭环数量',
            prop: 'complaintsInTimeCnt',
            width: '140px'
        },
        {
            label: '投诉工单总数量',
            prop: 'complaintsCnt',
            width: '110px'
        },
        {
            label: '投诉工单闭环及时率',
            prop: 'complaintsInTimePct',
            width: '130px'
        },
        {
            label: '异常工单及时闭环数量',
            prop: 'abnormalInTimeCnt',
            width: '140px'
        },
        {
            label: '异常工单总数量',
            prop: 'abnormalCnt',
            width: '110px'
        },
        {
            label: '异常工单闭环及时率',
            prop: 'abnormalInTimePct',
            width: '130px'
        },
        {
            label: '咨询工单及时闭环数量',
            prop: 'consultationInTimeCnt',
            width: '140px'
        },
        {
            label: '咨询工单总数量',
            prop: 'consultationCnt',
            width: '110px'
        },
        {
            label: '咨询工单闭环及时率',
            prop: 'consultationInTimePct',
            width: '130px'
        }
    ]
};

// 搜索条件
export const searchListConfig = [
    {
        prop: 'ebcdCode',
        name: '专业公司',
        type: 'select',
        placeholder: '请选择专业公司',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-personal-satisfaction-search-ebcdCode'
    },
    {
        prop: 'industryCategory',
        name: '行业大类',
        type: 'cascader',
        props: {
            multiple: true,
            value: 'code',
            label: 'name'
        },
        placeholder: '请选择行业大类',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-personal-satisfaction-search-industryCategory'
    },
    {
        prop: 'areaCode',
        name: '片区',
        type: 'select',
        placeholder: '请选择片区',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-personal-satisfaction-search-areaCode'
    },
    {
        prop: 'subBranchCode',
        name: '分公司',
        type: 'select',
        placeholder: '请选择分公司',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-personal-satisfaction-search-subBranchCode'
    },
    // {
    //     prop: 'dazhuangyegongsi',
    //     name: '大专司',
    //     type: 'select',
    //     placeholder: '请选择大专司',
    //     multiple: false,
    //     defaultValue: '整体',
    //     options: [
    //         {
    //             code: '整体',
    //             name: '整体'
    //         },
    //         {
    //             code: '城配送装',
    //             name: '城配送装'
    //         },
    //         {
    //             code: '零担干线',
    //             name: '零担干线'
    //         },
    //         {
    //             code: '生产物流',
    //             name: '生产物流'
    //         },
    //         {
    //             code: '非专司',
    //             name: '非专司'
    //         }
    //     ]
    // },
    {
        prop: 'customerlevelName',
        name: '客户等级',
        type: 'radio',
        placeholder: '请选择客户等级',
        fixed: 'left',
        className: 'bigData-btn-home-sub-personal-satisfaction-search-customerlevelName'
    },
    {
        prop: 'timeStatus',
        name: '时间',
        type: 'time',
        placeholder: '请选择时间',
        fixed: 'left',
        className: 'bigData-btn-home-sub-personal-satisfaction-search-timeStatus'
    }

];

export const updateTimeBigdataList = {
    resetClassName: 'bigData-btn-home-sub-personal-satisfaction-reset',
    closeClassName: 'bigData-btn-home-sub-personal-satisfaction-close'
};
